<div class="pb-6 bg-grey-200 page-padding-y">
  <ng-container *ngIf="SIMPublicationMetadata">
    <h5 class="mb-6 break-words page-padding-x text-darkBlue-500" id="h5-committee-code" >{{designation}}</h5>
    <div class="flex flex-col gap-2 page-padding-x 2xl:flex-row 2xl:gap-0">
          <h5 class="flex flex-wrap justify-start gap-2 break-words 2xl:w-1/2 place-items-start" id="document-detail-title">{{title}}</h5>
          <div class="flex justify-end gap-2 2xl:w-1/2 place-items-start">
            <app-sa-library-download [uri] = 'documentUri' [index] = 1 [fromDocumentSearch] = "false"></app-sa-library-download>
          </div>
    </div>
  </ng-container>
</div>

<div
  class="flex-1 pt-6 bg-grey-100 page-padding-x page-padding-b max-w-[100vw]"
>
  <ng-container *ngIf="SIMPublicationMetadata">
      <app-tab
          #appTab
          [tabs]="tabs"
          id="documentsTab"
          (onTabChange)="onTabChange($event)"
      >
      </app-tab>
      <div [class.hidden]="selectedTab !== tabIds.Overview">
        <app-card>
          <app-document-details-overview [SIMPublicationOverview] = "SIMPublicationOverview"></app-document-details-overview>
        </app-card>
      </div>
      <div [class.hidden]="selectedTab !== tabIds.Details">
        <app-card>
          <app-document-details-values [SIMPublicationDetails] = "SIMPublicationDetails"></app-document-details-values>
        </app-card>
      </div>
      <div [class.hidden]="selectedTab !== tabIds.KeyDates">
        <app-card>
          <app-document-details-key-dates [SIMPublicationKeyDates] = "SIMPublicationKeyDates"></app-document-details-key-dates>
        </app-card>
      </div>
  </ng-container>
  <ng-container *ngIf="loading">
    <div class="flex justify-center items-center h-full">
      <app-loading-indicator [size]="32"></app-loading-indicator>
    </div>
  </ng-container>
</div>
